import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import { Card } from 'react-bootstrap';
import ListaTutoriales from './ListaTutoriales';
import ButtonCreate from 'utils/buttons/ButtonCreate';
import CreateTutorialModal from './modals/CreateTutorialModal';
import { useSelector } from 'react-redux';

const Tutoriales = () => {
  const userLogged = useSelector(state => state.login.currentUser);
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      <PageHeader
        title="Tutoriales"
        description="En esta sección puedes encontrar el listado de tutoriales y manuales del sistema de CABAPROP."
        className="mb-3 bg-white"
      >
        {userLogged && userLogged.typeOfUser === 'cucicba' && (
          <ButtonCreate
            text="Nuevo Tutorial"
            funcion={handleShow}
            variant="primary"
          />
        )}
      </PageHeader>

      <CreateTutorialModal
        show={showModal}
        handleClose={handleClose}
        dialogClassName="modal-dialog-centered"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh'
        }}
      />

      <Card className="bg-white">
        <Card.Header className="d-flex justify-content-between">
          <Card.Title>
            <FontAwesomeIcon
              icon="fa-solid fa-list"
              className="text-dark"
              style={{ marginRight: 10, fontSize: 20 }}
            />
            Listado
          </Card.Title>
        </Card.Header>

        <Card.Body>
          <ListaTutoriales />
        </Card.Body>
      </Card>
    </>
  );
};

export default Tutoriales;
